<template>
  <v-container
    id="view-endpoint-single"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <Breadcrumb :items="items"></Breadcrumb>
        <h1>{{ developmentData.name }}</h1>
      </v-col>
    </v-row>



    <CreditBillingSingleHeader></CreditBillingSingleHeader>

    <v-row>
      <v-col cols="12">
        <v-alert
          v-if="developmentData.external_bills > 0"
          type="warning"
          class="warn"
          prominent
          border="left"
        >
          <strong>One or more bills require your approval</strong>
          <p>One or more bills requires your approval before the bills can be generated. <span v-if="developmentData.report_notification_emails">An approval e-mail was sent to {{ developmentData.report_notification_emails }}</span></p>
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" align="center">
        <router-link
          custom v-slot="{ navigate }"
          :to="`/credit-billing/${id}/bills`"
        >
          <v-btn
            class="ma-2"
            color="green" @click="navigate" role="link">
            View all Bills
          </v-btn>
        </router-link
        >
        <router-link
          custom v-slot="{ navigate }"
          :to="`/credit-billing/${id}/accounts`"
        >
          <v-btn
            class="ma-2"
            color="green" @click="navigate" role="link">
            View all Accounts
          </v-btn>
        </router-link
        >
        <router-link
          to="#bill-report-export"
        >
          <v-btn
            class="ma-2"
            color="green" role="link">
            Bill Report Export
          </v-btn>
        </router-link
        >
        <router-link
          custom v-slot="{ navigate }"
          :to="`/credit-billing/${id}/reports`"
        >
          <v-btn
            class="ma-2"
            color="green" @click="navigate" role="link">
            Reports
          </v-btn>
        </router-link
        >
      </v-col>
    </v-row>

    <CreditBillingSingleApartments v-if="developmentData.apartments.length > 0"></CreditBillingSingleApartments>

    <v-row>
      <v-col cols="6">
        <CreditBillingSingleBillOverview :id="id"></CreditBillingSingleBillOverview>

      </v-col>
      <v-col cols="6">
        <CreditBillingSingleFiles :id="id"></CreditBillingSingleFiles>
      </v-col>
    </v-row>

    <CreditBillingBillingRuns :id="id"></CreditBillingBillingRuns>

    <CreditBillingSingleTariffs></CreditBillingSingleTariffs>

    <CreditBillingBillExport :id="id"></CreditBillingBillExport>

  </v-container>
</template>

<script>
import {get} from "vuex-pathify";
import {date} from "@/mixins/date";
import Breadcrumb from "@/components/Breadcrumb";

import CreditBillingSingleHeader from "@/views/credit-billing/components/CreditBillingSingleHeader";
import CreditBillingSingleApartments from "@/views/credit-billing/components/CreditBillingSingleApartments";
import CreditBillingSingleBillOverview from "@/views/credit-billing/components/CreditBillingSingleBillOverview";
import CreditBillingSingleTariffs from "@/views/credit-billing/components/CreditBillingSingleTariffs";
import CreditBillingSingleFiles from "@/views/credit-billing/components/CreditBillingSingleFiles";
import CreditBillingBillingRuns from "@/views/credit-billing/components/CreditBillingBillingRuns";
import CreditBillingBillExport from "./components/CreditBillingBillExport.vue";

export default {
  name: "CreditBillingSingle",
  props: {
    id: String
  },
  components: {
    CreditBillingBillExport,
    Breadcrumb,
    CreditBillingSingleHeader,
    CreditBillingSingleApartments,
    CreditBillingSingleBillOverview,
    CreditBillingSingleTariffs,
    CreditBillingSingleFiles,
    CreditBillingBillingRuns
  },
  metaInfo () {
    return {
      title: this.developmentData.name
    }
  },
  computed: {
    developmentData: get('creditBilling/development'),
    developmentRef: get('creditBilling/developmentRef'),
    developmentUpdated: get('creditBilling/developmentUpdated'),
    items() {
      return [
        {
          text: 'All Developments',
          disabled: false,
          exact: true,
          to: '/credit-billing',
        },
        {
          text: this.developmentData.name,
          disabled: true
        }
      ];
    }
  },
  mixins: [date],
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: () => ({
    loaded: false
  }),
  methods: {
    headerColor(value) {
      if (!value || value === 0) {
        return '#FB8C00';
      }
      return '#5d3791';
    },
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Loading Development" });

      const success = await this.$store.dispatch("creditBilling/getDevelopment", { developmentRef: this.id});
      if (!success) {
        await this.$router.push("/credit-billing");
        return;
      }

      await this.$store.dispatch("loader/loaderCancel");

      this.loaded = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.warn p {
  margin-bottom: 0px;
  font-size: 0.9rem;
}
</style>
